import { render, staticRenderFns } from "./Security.vue?vue&type=template&id=998a779a&scoped=true"
import script from "./Security.vue?vue&type=script&lang=js"
export * from "./Security.vue?vue&type=script&lang=js"
import style0 from "./Security.vue?vue&type=style&index=0&id=998a779a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998a779a",
  null
  
)

export default component.exports